export default __webpack_public_path__ + "static/media/cert-general2024-consumer.81565a44.jpg";